import { render } from "./UnsavedChangesDialog.vue?vue&type=template&id=fe2a6668&scoped=true"
import script from "./UnsavedChangesDialog.vue?vue&type=script&lang=js"
export * from "./UnsavedChangesDialog.vue?vue&type=script&lang=js"

import "./UnsavedChangesDialog.vue?vue&type=style&index=0&id=fe2a6668&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe2a6668"]])

export default __exports__